import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'

import get from 'lodash/get'
import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'estado',
    ...crudState()
  }),
  getters: {
    ...crudGetters
  },
  mutations: {
    ...crudMutations
  },
  actions: {
    ...crudActions,
    async movePos ({ commit, state }, { id, action }) {
      if (id <= 0) {
        return Promise.reject(new Error())
      }

      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.post(`${state.endpoint}/${action}pos`, { id })
        const data = get(response, 'data.data', [])
        commit('setLoading', -1, { root: true })

        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    }
  }
}
